export function median(values: readonly number[]): number | null {
  if (values.length === 0) return null
  const sorted = [...values].sort((a, b) => a - b)
  const middle = Math.floor(sorted.length / 2)
  const high = sorted[middle] ?? 0
  return sorted.length % 2 === 1 ? high : ((sorted[middle - 1] ?? 0) + high) / 2
}

export function roundTo(value: number | null, places = 1): number | null {
  if (value === null || !Number.isFinite(value)) return null
  const factor = 10 ** places
  return Math.round(value * factor) / factor
}
